import React from 'react'
import { LayoutWithStandardHeader } from 'stylist'
import MainHeader from 'components/MainHeader'
import { Route, Switch } from 'react-router-dom'
import EnsureSession from 'components/EnsureSession'
import EnsureAdmin from 'components/EnsureAdmin'
import RouteAdminIndex from './admin/index'
import RouteAdminUsers from './admin/users'
import RouteAdminFeatures from './admin/features'
import RouteAdminFeedback from './admin/feedback'
import styled from 'react-emotion'

const StandardLayoutForSubheader = styled(LayoutWithStandardHeader)`
  grid-template-rows: auto auto 1fr auto;
`

const RouteAdmin = ({ match: { path } }) => (
  <StandardLayoutForSubheader>
    <MainHeader />
    <LayoutWithStandardHeader.Main>
      <Switch>
        <EnsureSession>
          <EnsureAdmin>
            <Route exact path={path} component={RouteAdminIndex} />
            <Route path={`${path}/users`} component={RouteAdminUsers} />
            <Route path={`${path}/features`} component={RouteAdminFeatures} />
            <Route path={`${path}/feedback`} component={RouteAdminFeedback} />
          </EnsureAdmin>
        </EnsureSession>
      </Switch>
    </LayoutWithStandardHeader.Main>
  </StandardLayoutForSubheader>
)

export default RouteAdmin



// WEBPACK FOOTER //
// ./src/routes/admin.js